import { render, staticRenderFns } from "./RegProductPallet.vue?vue&type=template&id=e1c144b0&"
import script from "./RegProductPallet.vue?vue&type=script&lang=js&"
export * from "./RegProductPallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports